import React, { ChangeEvent, FormEvent, useEffect, useState, Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'
import { Passenger, PassengerAuthorization } from '../../../types/common.types'
import GeneralInput from '../../../components/common/GeneralInput'
import { usePassenger } from '../../../context/passenger'
import CountryInput from '../../common/CountryInput'
import PassengerService from '../../../services/passenger.service'
import { useGlobal } from '../../../context/global'

export default function Info({isInfoOpen, setIsInfoOpen}: {isInfoOpen: boolean | null, setIsInfoOpen: Dispatch<SetStateAction<boolean | null>>}) {
    const { setIsLoading } = useGlobal()
    const {user} = usePassenger()
    const [data, setData] = useState<Passenger>((user?.user?.passenger || {}) as Passenger)
    const [request, setRequest] = useState<PassengerAuthorization | null>(null)
    useEffect(() => {
        if(user?.user?.passenger) setData(user?.user?.passenger)
        if(user?.user?.requests) setRequest(user?.user?.requests)
    }, [user?.user?.passenger, user?.user?.requests])
    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const value = e.target.value
        const name = e.target.name
        setData(prevData => ({...prevData, [name]: value}))
    }
    function onSelectCountry(e: ChangeEvent<HTMLSelectElement>) {
        const name = e.target.name
        const value = e.target.value
        setData((prevData) => ({...prevData, [name]: value}))
    }
    async function onSubmit(e: FormEvent<HTMLFormElement>) {
        e.preventDefault()
        if (request) return alert('You already have a pending request, please wait for it to be reviewed by administration')
        setIsLoading(true)
        try {
            const newData: PassengerAuthorization = {
                name: data.name || undefined,
                email: data.email || undefined,
                rut_passport: data.rut_passport || undefined,
                phone: data.phone || undefined,
                age: data.age || undefined,
                hotel: data.hotel || undefined,
                nationality: data.nationality || undefined,
                remark: data.remark || undefined
            } as PassengerAuthorization
            await PassengerService.createPassengerAuthorization(newData)
            window.location.reload()
        } catch (error) {
            console.log(error)
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Main isInfoOpen={isInfoOpen}
        onSubmit={onSubmit}
        >
            <div className="container">
                <GeneralInput
                name='name'
                label='Name'
                value={request?.name || data.name || ''}
                onChange={onChange}
                disabled={!!request}
                required
                />
                <GeneralInput
                name='email'
                label='Email'
                type='email'
                value={ request?.email || data.email || ''}
                onChange={onChange}
                disabled={!!request}
                required
                />
            </div>
            <div className="container">
                <GeneralInput
                name='rut_passport'
                label='RUT/Passport'
                value={request?.rut_passport || data.rut_passport || ''}
                onChange={onChange}
                disabled={!!request}
                />
                <GeneralInput
                name='phone'
                label='Phone'
                value={request?.phone || data.phone || ''}
                onChange={onChange}
                disabled={!!request}
                />
            </div>
            <div className='container'>
                <GeneralInput
                name='age'
                label='Age'
                type='number'
                value={request?.age || data.age || ''}
                onChange={onChange}
                disabled={!!request}
                />
                <GeneralInput
                name='hotel'
                label='Hotel'
                value={request?.hotel || data.hotel || ''}
                onChange={onChange}
                disabled={!!request}
                />
            </div>
            <div className='container'>
                <GeneralInput
                name='remark'
                label='Remark'
                value={request?.remark || data.remark || ''}
                onChange={onChange}
                disabled={!!request}
                />
                <div className="locations">
                    <CountryInput
                    label='Nationality'
                    value={request?.nationality || data.nationality}
                    name='nationality'
                    disabled={!!request}
                    onChange={onSelectCountry}
                    />  
                </div>
            </div>
            {
                request 
                ? <p style={{color: 'orange', textAlign: 'center'}}>You have a pending request, please wait for it to be reviewed by administration</p>
                :
                <button 
                type="submit"
                >Submit</button>
            }
        </Main>
    )
}

const Main = styled.form<{isInfoOpen: boolean | null}>`
  overflow: hidden;
  height: ${({isInfoOpen}) => (isInfoOpen ? 'auto' : '0')};
  transition: height 0.3s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
  .locations {
display: flex;
gap: 20px;
margin-bottom: 20px;
}
  .container {
    padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: 100%;

    > div {
        flex: 1;
        min-width: 200px;
    }
  }

  button {
    display: inline-block;
    padding: 0 10px;
    height: 2.6em;
    line-height: 2.5em;
    overflow: hidden;
    font-size: 17px;
    z-index: 1;
    background-color: ${props => props.theme.white};
    color: ${props => props.theme.blue};
    border: 2px solid ${props => props.theme.blue};
    border-radius: 6px;
    position: relative;
    cursor: pointer;
}

button::before {
    position: absolute;
    content: "";
    background: ${props => props.theme.blue};
    width: calc(100% + 100px);
    height: 200px;
    z-index: -1;
    border-radius: 50%;
}

button:hover {
    color: ${props => props.theme.white};
}

button:before {
    top: 100%;
    left: 100%;
    transition: .3s all;
}

button:hover::before {
    top: -30px;
    left: -30%;
}
`;